import { UrlObject } from 'url'

import { OrderFormat } from '@ancon/wildcat-types'
import moment from 'moment'

import { AppRoutes, OrderFormatSlugMap } from '../../app/constants'

export default function getPreOrderPageURL(
  outletSlug: string,
  orderFormat: OrderFormat,
  /** Timestamp of the order time, when one was chosen */
  serviceTime?: number,
): UrlObject {
  return {
    pathname: `${AppRoutes.Outlet}/${outletSlug}`,
    query: {
      orderFormat: OrderFormatSlugMap[orderFormat as never],
      ...(serviceTime !== undefined && {
        serviceTime: moment(serviceTime).toISOString(),
      }),
    },
  }
}
